// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"bbv_a bhv_g"};